import { useRouter } from 'next/router'

const useTextDirection = () => {
  const { locale } = useRouter()

  const rtlLocales = ['he-IL'];

  return rtlLocales.includes(locale) ? 'rtl' : 'ltr';
}

export default useTextDirection
